export default __webpack_public_path__ + "static/media/footer-logo.0ceae7b6.png";